import styled from '@emotion/styled';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { JSX } from 'react';
import { COLOR, GREYSCALE } from '../styles/colors';
import { CUSTOM_ICON_DATA } from '../styles/icons';
import { SPACING } from '../styles/spacing';
import { TYPOGRAPHY } from '../styles/typography';
import carrierKeyToIconUrl from '../utils/carrierKeyToIconUrl';

export type CustomIconName = (typeof CUSTOM_ICON_DATA)[number]['iconName'];

export interface IconProps extends Omit<FontAwesomeIconProps, 'icon'> {
  icon: CustomIconName | IconProp;
}

function Icon(props: IconProps): JSX.Element {
  const { icon } = props;
  return <FontAwesomeIcon {...props} icon={icon as IconProp} />;
}

const Styled = {
  CarrierIcon: styled.img<{ carrierKey: string }>`
    height: ${({ carrierKey }) => {
      switch (carrierKey) {
        case 'UPS':
          return '22px';
        case 'USPS':
          return '17px';
        default:
          return '17px';
      }
    }};
  `,
  TooltipIcon: styled(Icon)`
    min-width: ${SPACING.lg};
    height: ${SPACING.lg};
    margin: 0 ${SPACING.xs};
    font-size: ${TYPOGRAPHY.fontSize.xs};
    color: ${GREYSCALE.grey50};
    vertical-align: middle;
    cursor: pointer;
    &:hover {
      color: ${COLOR.darkBlue};
    }
  `,
};

export type CarrierIconProps = {
  carrierKey: string;
  mailClassKey?: string | null;
};

export function CarrierIcon({ carrierKey, mailClassKey }: CarrierIconProps): JSX.Element {
  return (
    <Styled.CarrierIcon
      src={carrierKeyToIconUrl(carrierKey, mailClassKey)}
      carrierKey={carrierKey}
      data-testid={carrierKey}
    />
  );
}

export type TooltipIconProps = {
  id: string;
};

export function TooltipIcon({ id }: TooltipIconProps) {
  return <Styled.TooltipIcon id={id} icon="circle-question" />;
}

export default Icon;
